import { loadRegionList, loadList, loadLabelList } from '@/api/home'
import { getAreaStr } from '@/common/js/utils.js'
import { config } from '../constant/config'
export const queryListMixin = {
  data () {
    return {
      // 分页
      page: 1,
      limit: 10,
      totalCount: 0,
      // 条件筛选
      selectedList: [],
      optionList: [
        {
          label: '标签',
          option: []
        },
        {
          label: '星级',
          option: []
        },
        {
          label: '区域',
          option: []
        }
      ],
      // 排序
      sortArr: [
        { code: null, label: '智能排序', isSelected: true },
        { code: 'consumptionPerPerson', label: '价格排序', isSelected: false, status: null }, // status: null没选 asc升序 desc降序
        { code: 'sales', label: '人气最高', isSelected: false },
        { code: 'avgReviewScore', label: '评价最优', isSelected: false }
      ],
      // 列表
      list: []
    }
  },
  created () {
    this.loadList()
    this.loadLabelList()
    this.loadRegionList()
  },
  methods: {
    loadList () {
      const param = {
        saleStations: [config.SALESTATIONS],
        modules: [this.modules],
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        lon: 0,
        lat: 0,
        limit: this.limit,
        page: this.page,
        name: null,
        sortList: [],
        typeCode: this.typeCode,
        tags: []
      }
      // 筛选条件处理
      param.tags = this.selectedList.filter(item => item.type === 'tag').map(item => item.id)
      param.regionIds = this.selectedList.filter(item => item.type === 'region').map(item => item.id)
      const starArr = this.selectedList.filter(item => item.type === 'star').map(item => item.id)
      if (starArr.findIndex(val => val === 2) !== -1) {
        starArr.push(1)
      }
      param.levels = starArr.length > 0 ? starArr : null
      // 排序处理
      // filed 筛选条件key(价格：consumptionPerPerson、等级：level)
      // orders 筛选条件value,与上面sortArray需一一对应
      const sort = this.sortArr.filter(item => item.isSelected && item.code != null)[0]
      if (sort) {
        const filed = sort.code
        const orders = sort.status || 'desc'
        param.sortList.push({
          filed,
          orders
        })
      }
      loadList(param).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.list) {
            res.data.list.forEach(item => {
            // 图片解析
              const pictures = item.pictures ? JSON.parse(item.pictures) : []
              const mainPics = pictures.filter(item => item.index === 1) // 首图index为1
              if (mainPics[0] && mainPics[0].url) {
                // todo 后台将首图存成数组
                if (Array.isArray(mainPics[0].url)) {
                  item.mainPic = mainPics[0].url[0]
                } else {
                  item.mainPic = mainPics[0].url
                }
              }
              // 地址解析
              const areaStr = getAreaStr(item.addressProvinceCode, item.addressCityCode, item.addressCountyCode)
              item.addressDetails = areaStr + item.addressDetails
            })
          } else {
            this.list = []
            this.totalCount = 0
          }
          this.list = res.data == null ? [] : res.data.list
          this.totalCount = res.data == null ? 0 : res.data.totalCount
          this.page = res.data == null ? this.page : res.data.currPage
        }
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.loadList()
    },
    // 选择条件
    handleSelect (index, i, it) {
      this.page = 1
      this.$set(this.optionList[index].option[i], 'isSelected', !it.isSelected)
      this.dealSelectedList(it, 'load')
    },
    // 全选
    handleSelectAll (index, item) {
      this.page = 1
      const isAllSelected = item.isAllSelected
      this.$set(this.optionList[index], 'isAllSelected', !isAllSelected)
      this.optionList[index].option.forEach(val => {
        val.isSelected = !isAllSelected
        this.dealSelectedList(val)
      })
      this.loadList()
    },
    // 处理选中的条件
    dealSelectedList (it, flag) {
      const findIndex = this.selectedList.findIndex(val => val.id === it.id && val.name === it.name)
      if (it.isSelected) {
        if (findIndex === -1) {
          this.selectedList.push(it)
        }
      } else {
        this.selectedList.splice(findIndex, 1)
      }
      if (flag && flag === 'load') {
        this.loadList()
      }
    },
    // 删除已选条件
    handleDeleteSelected (index, item) {
      this.optionList.forEach(val => {
        val.option.forEach(v => {
          if (item.id === v.id && item.name === v.name) {
            v.isSelected = false
          }
        })
      })
      this.selectedList.splice(index, 1)
      this.loadList()
    },
    // 清除全部
    handleDeleteAll () {
      this.optionList.forEach(val => {
        val.isAllSelected = false
        val.option.forEach(v => {
          v.isSelected = false
        })
      })
      this.selectedList = []
      this.loadList()
    },
    // 点击排序
    handleSort (item) {
      this.sortArr.forEach(val => {
        val.isSelected = false
        if (val.code === item.code) {
          val.isSelected = true
        }
      })
      // 价格排序处理
      if (item.code === 'consumptionPerPerson') {
        const status = this.sortArr[1].status
        if (!status) {
          this.sortArr[1].status = 'asc'
        } else {
          this.$set(this.sortArr[1], 'status', this.sortArr[1].status === 'asc' ? 'desc' : 'asc')
        }
      } else {
        this.sortArr[1].status = null
      }
      this.loadList()
    },

    // 加载区域列表
    loadRegionList () {
      const param = {
        merchId: config.MERCHID,
        subDomain: config.SUBDOMAIN
      }
      loadRegionList(param).then(res => {
        if (res.code === 0) {
          const index = this.optionList.findIndex(val => val.label === '区域')
          this.optionList[index].option = res.data.map(val => {
            val.name = val.regionName
            val.type = 'region'
            return val
          })
        }
      })
    },
    // 加载标签
    loadLabelList () {
      const param = {
        merchId: config.MERCHID,
        subDomain: config.SUBDOMAIN,
        typeCode: this.typeCode
      }
      loadLabelList(param).then(res => {
        if (res.code === 0) {
          this.optionList[0].option = res.data.map(item => {
            item.type = 'tag'
            return item
          })
        }
      })
    }
  }
}
